
import React from 'react'

// components
import {
  CCol,
  CFormLabel,
  CFormText,
  CImage,
} from '@coreui/react-pro'

const AppImageDetail = ({
  colSize,
  className,
  title,
  images,
  handleViewFile
}) => {
  return (
    <CCol lg={colSize} className={className}>
      <CCol lg='12'>
        <CFormLabel>
          {title}
        </CFormLabel>
      </CCol>
      <CCol lg='12'>
        <CImage
          rounded
          className='mt-2 border p-1'
          src={images}
          width={300}
          height={300}
          style={{ objectFit: "contain" }}
          onClick={() => handleViewFile(images)}
        />
      </CCol>
      {(!images || images <= 0) && (
        <CFormText>
          No image provided
        </CFormText>
      )}
    </CCol>
  )
}

export default AppImageDetail
